import appConstants from "./../../../../../../appConstants";
import { MultiSelectFilter } from '@dataGrid/components/columnFilters';
import { CustomerNameCellRenderer } from '../../../../../common/CustomerMergeIndicator/CustomerNameCell';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }


  static isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    return displayedColumns[0] === params.column;
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.ReturnsGrid,
      keyColumn: "proId",
      rowSelection: "multiple",
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columns: [
        {
          headerName : "",
          checkboxSelection : true,
          headerCheckboxSelection : true,
          headerClass: "checkBoxHeader",
          cellClass: "gridCell-centerAlign",
          minWidth: appConstants.columnWidth.W_62,
          maxWidth: appConstants.columnWidth.W_62,
        },
        {
          headerName: "Pro #",
          field: "proId",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          filterParams: {
            filterType: appConstants.FILTER_TYPES.STRING,
          },
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "Customer",
          field: "displayCustomerName",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
          cellRenderer: CustomerNameCellRenderer,
        },
        {
          headerName: "Address",
          field: "address1",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "City",
          field: "city",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "State",
          field: "state",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "Zip",
          field: "zip",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "HU",
          field: "hu",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
      ],
    };
  }
}
